import React from "react";

const CardDeal = () => {
  return <div></div>;
};

export default CardDeal;
